import FormBody from 'components/organisms/Login/FormBody'
import React from 'react'

const Login: React.VFC = () => {
  return <FormBody />
}

export default Login
